const zones = [
    {
        "id": "telok panglima garang", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": ["42500"],

            "range":

                [

                ]



        }

    },

    {
        "id": "telok panglima garang", "logistic_type": "sameday", "price": "15",

        "poscodes":

        {

            "list": ["41200"],

            "range":

                [

                ]



        }

    }

    ,

    {
        "id": "Jenjarom, Banting, Telok Panglima Garang", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": ["42600", "42700", "42800"],

            "range":

                [

                ]



        }

    }

    ,

    {
        "id": "kuala lumpur city center", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "50000", "to": "50999" }

                ]



        }

    }

    ,

    {
        "id": "jalan klang lama", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "58000", "to": "58999" }

                ]



        }

    }

    ,

    {
        "id": "jalan pantai bharu", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "59000", "to": "59999" }

                ]



        }

    }

    ,

    {
        "id": "sentul, segambut", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "51000", "to": "51999" }

                ]



        }

    }

    ,

    {
        "id": "jinjang", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "52000", "to": "52099" }

                ]



        }

    }

    ,

    {
        "id": "kepong", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "52100", "to": "52199" }

                ]



        }

    }

    ,

    {
        "id": "bandar manjalara, bandar sri damansara", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "52200", "to": "52299" }

                ]



        }

    }

    ,

    {
        "id": "pudu, jalan imbi", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "55000", "to": "55099" }

                    , { "from": "55400", "to": "55999" }

                ]



        }

    }

    ,

    {
        "id": "kampung pandan", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "55100", "to": "55199" }

                ]



        }

    }

    ,

    {
        "id": "chan sow lin", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "55200", "to": "55299" }

                ]



        }

    }

    ,

    {
        "id": "pandan perdana", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "55300", "to": "55399" }

                ]



        }

    }

    ,

    {
        "id": "cheras", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "56000", "to": "56199" }

                ]



        }

    }

    ,

    {
        "id": "sungai besi (Bukit Jalil)", "logistic_type": "sameday", "price": "15",

        "poscodes":

        {

            "list": ["57000"],

            "range":

                []



        }

    }

    ,

    {
        "id": "sungai besi", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "57000", "to": "57999" }

                ]



        }

    }

    ,

    {
        "id": "petaling jaya", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "46000", "to": "46999" }

                    , { "from": "47300", "to": "47399" }

                ]



        }

    }

    ,

    {
        "id": "petaling jaya utara", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "47400", "to": "47499" }

                ]



        }

    }

    ,

    {
        "id": "mutiara damansara", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "47800", "to": "47899" }

                ]



        }

    }

    ,

    {
        "id": "taman tun dr ismail", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "60000", "to": "60999" }

                ]



        }

    }

    ,

    {
        "id": "subang airport", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "47200", "to": "47299" }

                ]



        }

    }

    ,

    {
        "id": "subang jaya", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "47500", "to": "47599" }

                ]



        }

    }

    ,

    {
        "id": "USJ", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "47600", "to": "47699" }

                ]



        }

    }

    ,

    {
        "id": "puchong", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": ["47120", "47130"],

            "range":

                []



        }

    }

    ,

    {
        "id": "puchong", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "47100", "to": "47199" }

                ]



        }

    }

    ,

    {
        "id": "klang", "logistic_type": "sameday", "price": "20", "exclude": false,

        "poscodes":

        {

            "list": ["42100"],

            "range":

                [

                    { "from": "41000", "to": "41999" }

                ]



        }

    }

    ,

    {
        "id": "pelabuhan klang", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "42000", "to": "42099" }

                ]



        }

    }

    ,

    {
        "id": "kapar", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "42200", "to": "42299" }

                ]



        }

    }

    ,

    {
        "id": "shah alam", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "40000", "to": "40999" }

                ]



        }

    }

    ,

    {
        "id": "bukit kemuning", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "42450", "to": "42499" }

                ]



        }

    }

    ,

    {
        "id": "bandar saujana putra", "logistic_type": "sameday", "price": "15", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "42610", "to": "42619" }

                ]



        }

    }

    ,

    {
        "id": "kajang", "logistic_type": "sameday", "price": "25",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43000", "to": "43099" }

                ]



        }

    }

    ,

    {
        "id": "hulu langat", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43100", "to": "43199" }

                ]



        }

    }

    ,

    {
        "id": "batu 9, jalan cheras", "logistic_type": "sameday", "price": "20",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43200", "to": "43299" }

                ]



        }

    }

    ,

    {
        "id": "seri kembangan", "logistic_type": "sameday", "price": "20",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43300", "to": "43399" }

                ]



        }

    }

    ,

    {
        "id": "UPM Serdang", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43400", "to": "43499" }

                ]



        }

    }

    ,

    {
        "id": "semenyih", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43500", "to": "43599" }

                ]



        }

    }

    ,

    {
        "id": "bangi", "logistic_type": "sameday", "price": "25",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43600", "to": "43699" }

                ]



        }

    }

    ,

    {
        "id": "beranang", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43700", "to": "43799" }

                ]



        }

    }

    ,

    {
        "id": "dengkil", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43800", "to": "43899" }

                ]



        }

    }

    ,

    {
        "id": "sepang", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "43900", "to": "43999" }

                ]



        }

    }

    ,

    {
        "id": "putrajaya", "logistic_type": "sameday", "price": "25", "exclude": false,

        "poscodes":

        {

            "list": ["62000", "62007", "62050", "62050", "62100", "62150", "62200", "62250", "62300", "62502", "62504", "62505", "62506", "62510", "62512", "62514", "62516", "62517", "62518", "62519", "62520", "62522", "62524", "62526", "62527", "62530", "62532", "62536", "62540", "62542", "62546", "62550", "62551", "62570", "62574", "62576", "62582", "62584", "62590", "62592", "62594", "62596", "62602", "62604", "62605", "62606", "62616", "62618", "62620", "62623", "62624", "62628", "62630", "62632", "62648", "62652", "62654", "62662", "62668", "62670", "62674", "62675", "62676", "62677", "62686", "62692", "62988"],

            "range":

                []



        }

    }

    ,

    {
        "id": "putrajaya", "logistic_type": "sameday", "price": "25", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "62000", "to": "62999" }

                ]



        }

    }

    ,

    {
        "id": "cyberjaya", "logistic_type": "sameday", "price": "25", "exclude": false,

        "poscodes":

        {

            "list": ["63100", "63200", "63300"],

            "range":

                []



        }

    }

    ,

    {
        "id": "cyberjaya", "logistic_type": "sameday", "price": "25", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "63000", "to": "63199" }

                ]



        }

    }

    ,

    {
        "id": "sungai buluh", "logistic_type": "sameday", "price": "15",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "47000", "to": "47099" }

                ]



        }

    }

    ,

    {
        "id": "rawang", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "48000", "to": "48049" }

                ]



        }

    }

    ,

    {
        "id": "gombak, setapak, wangsa maju", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": ["52300"],

            "range":

                [

                    { "from": "53000", "to": "53999" }

                ]



        }

    }

    ,

    {
        "id": "kampung datuk keramat", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "54000", "to": "54099" }

                ]



        }

    }

    ,

    {
        "id": "semarak, kementah, desa tun hussein onn", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "54100", "to": "54199" }

                ]



        }

    }

    ,

    {
        "id": "setiawangsa", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "54200", "to": "54299" }

                ]



        }

    }

    ,

    {
        "id": "ampang", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "68000", "to": "68099" }

                ]



        }

    }

    ,

    {
        "id": "batu caves, Selayang", "logistic_type": "sameday", "price": "15",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "68100", "to": "68199" }

                ]



        }

    }

    ,

    {
        "id": "KLIA Sepang", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "64000", "to": "64099" }

                ]



        }

    }

    ,

    {
        "id": "kuala lumpur", "logistic_type": "sameday", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "50000", "to": "60000" }

                ]



        }

    }

    ,

    {
        "id": "labuan", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "87000", "to": "87033" }

                ]



        }

    }

    ,

    {
        "id": "selangor", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": ["40300", "40301"],

            "range":

                [

                    { "from": "40000", "to": "48300" },

                    { "from": "63000", "to": "68100" }

                ]



        }

    }

    ,

    {
        "id": "terengganu", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "20000", "to": "24300" }

                ]



        }

    }

    ,

    {
        "id": "kedah", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "05000", "to": "09810" }

                ]

        }

    }

    ,

    {
        "id": "kelantan", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "14000", "to": "18500" }

                ]

        }

    }

    ,

    {
        "id": "negeri sembilan", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "70000", "to": "73509" }

                ]

        }

    }

    ,

    {
        "id": "pulau pinang", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "10000", "to": "14400" }

                ]

        }

    }

    ,

    {
        "id": "johor", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "79000", "to": "86900" }

                ]

        }

    }

    ,

    {
        "id": "melaka", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "75000", "to": "78309" }

                ]

        }

    }

    ,

    {
        "id": "perlis", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "01000", "to": "02000" }

                ]

        }

    }

    ,

    {
        "id": "perak", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "30000", "to": "36810" }

                ]

        }

    }

    ,

    {
        "id": "pahang", "logistic_type": "nationwide", "price": "0",

        "poscodes":

        {

            "list": ["49000", "69000"],

            "range":

                [

                    { "from": "25000", "to": "28800" }

                    , { "from": "39000", "to": "39200" }

                ]

        }

    }

    ,

    {
        "id": "sarawak", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "93000", "to": "98859" }

                ]

        }

    }

    ,

    {
        "id": "sabah", "logistic_type": "nationwide", "price": "0", "exclude": false,

        "poscodes":

        {

            "list": [],

            "range":

                [

                    { "from": "88000", "to": "91309" }

                ]

        }

    }

]


export default (zip) => {
    zip = zip.toString();
    const res = zones.filter(zone => {
        let hasZip = false;
        if(zone.poscodes.list.length){
            hasZip = zone.poscodes.list.includes(zip)
            if(hasZip){
                return true
            }
        }

        if(zone.poscodes.range.length){
            for(let range of zone.poscodes.range){
                hasZip = Number(zip) >= Number(range.from) && Number(zip) <= Number(range.to)
                if(hasZip){
                    return true;
                }
            }
        }

        return hasZip;
    })

    if(res.length) 
        return res[0].logistic_type;

    return false;
}